import { POST_METHOD } from './ApiMethods';

export const postResetDetails = async (details) => {
    try {
        let response = await POST_METHOD('password-reset', details);
        return response;
    } catch (error) {
        return error;
    }
};
export const postResetRequest = async (details) => {
    try {
        let response = await POST_METHOD('send/password-reset/link', details);
        return response;
    } catch (error) {
        return error;
    }
};
export const postValidateCandidate = async (details) => {
    try {
        let response = await POST_METHOD('verify/password-reset/link', details);
        return response;
    } catch (error) {
        return error;
    }
};
